import { z } from "zod";
/**
 * `GET /me/stats` — the streak and the milestones (`D152`).
 *
 * ── SERVER-COMPUTED, BECAUSE THE CLIENT CANNOT SEE FAR ENOUGH ───────────────
 * A streak longer than the app's history window cannot be known on the
 * device: a twelve-week window cannot see a fourteen-week streak, and the
 * uncapped read that could is billed per row (`T-6`). So the server counts,
 * and this is what it says.
 *
 * ── WEEKS, NOT DAYS ─────────────────────────────────────────────────────────
 * A week is FULL when its ended sessions reach the plan's `daysPerWeek`;
 * weeks are seven-day blocks anchored to the plan's own anchor (`D150`), and
 * a missed week between two full ones is bridged once per thirteen weeks by
 * an automatic freeze. Nothing here pushes (`D100`): the streak is shown on
 * home beside the week, and a milestone is named once, on the summary.
 */
/**
 * The five milestones, in the order they are usually reached. `first_pr` is
 * the first personal record that BEAT an earlier estimate — the first logged
 * lift is `firstEver` on the summary, not a milestone.
 */
export const MILESTONES = [
    "first_pr",
    "sessions_10",
    "sessions_30",
    "sessions_100",
    "three_months",
];
export const milestone = z.enum(MILESTONES);
export const milestoneReached = z.object({
    milestone,
    reachedAt: z.iso.datetime(),
    /** The session that reached it — a milestone is a moment, and it links back. */
    sessionId: z.string().min(1),
});
export const trainingStats = z.object({
    /** Whether the next missed week would be bridged rather than break the run. */
    freezeAvailable: z.boolean(),
    milestones: z.array(milestoneReached),
    /** Consecutive full weeks, freezes included. `0` before the first full one. */
    streakWeeks: z.int().nonnegative(),
    /** This week's count against the plan's `daysPerWeek` — what home draws. */
    thisWeek: z.object({
        done: z.int().nonnegative(),
        scheduled: z.int().nonnegative(),
    }),
    /** Ended sessions, ever — what `sessions_10` and its siblings count. */
    totalSessions: z.int().nonnegative(),
    /** `true` once `thisWeek.done` has reached `thisWeek.scheduled`. */
    weekFull: z.boolean(),
});
//# sourceMappingURL=stats.js.map